<div class="privacy-policy-container">
  <header class="privacy-header">
    <h1>Privacy Policy</h1>
    <p>
      This Privacy Policy explains how we collect, use, and safeguard your information when using the
      <strong>Crate Management Solution</strong>. It is designed for Drivers, Stores, and Processing Plants
      in FMCG, Dairy, Food Processing, and other industries.
    </p>
  </header>

  <main class="privacy-content">
    <section>
      <h2>1. Consent</h2>
      <p>
        By using our Crate Management Solution, you consent to this Privacy Policy and agree to its terms.
      </p>
    </section>

    <section>
      <h2>2. Interpretation & Definitions</h2>
      <ul>
        <li><strong>Company:</strong> Prompt Equipments Pvt. Ltd., 7th Floor, Shaligram Corporates, C. J. Road, Iskon - Ambli Road, Ahmedabad, Gujarat - 380058.</li>
        <li><strong>Country:</strong> India.</li>
        <li><strong>Device:</strong> Any mobile device running the Android or iOS operating system.</li>
        <li><strong>Personal Data:</strong> Any information that relates to an identified or identifiable individual.</li>
        <li><strong>You:</strong> The individual or organization accessing or using the Service.</li>
      </ul>
    </section>

    <section>
      <h2>3. Permissions Used</h2>
      <p>Our application uses only the following permissions, strictly for functional purposes:</p>
      <ul>
        <li><strong>Internet:</strong> Required to upload and synchronize data with the server.</li>
        <li><strong>Access Network State:</strong> Used to check network connectivity status before performing online operations.</li>
        <li><strong>Vibrate:</strong> Utilized for haptic feedback within the application.</li>
        <li><strong>Camera:</strong> Required to capture images using CameraX for crate management and verification.</li>
        <li><strong>Location:</strong> Used to identify the user's location while scanning crates at different sites, ensuring traceability.</li>
      </ul>
    </section>

    <section>
      <h2>4. Data Usage & Security</h2>
      <ul>
        <li>All data collected is used only for crate tracking and supply chain traceability.</li>
        <li>We do not sell, share, or transfer data to third parties outside the project scope.</li>
        <li>Data is encrypted and secured both in transit and at rest using industry-standard practices.</li>
      </ul>
    </section>

    <section>
      <h2>5. Data Visibility & Disclosure</h2>
      <ul>
        <li>Information collected is visible only to authorized users as per their role (Driver, Store, Plant).</li>
        <li>
          Data will not be shared externally, except in the case of legal obligations or a change in company ownership,
          in which case you will be notified.
        </li>
      </ul>
    </section>

    <section>
      <h2>6. Opt-Out Options</h2>
      <p>
        You may stop all information collection by uninstalling the application using the standard uninstall process on your device.
      </p>
    </section>

    <section>
      <h2>7. Children's Privacy</h2>
      <p>
        The Service is not intended for children under 13 years of age. We do not knowingly collect information from children.
        If such data is found, it will be deleted immediately.
      </p>
    </section>

    <section>
      <h2>8. Changes to this Policy</h2>
      <p>
        We may update this Privacy Policy from time to time. Any changes will be communicated via app notification or a
        prominent notice on our website. Updates will take effect once posted.
      </p>
    </section>

    <section>
      <h2>9. Contact Us</h2>
      <p>If you have questions about this Privacy Policy, please contact us:</p>
      <ul>
        <li><strong>Email: </strong> <a href="mailto:info@promptdairytech.com">info&#64;promptdairytech.com</a></li>
        <li><strong>Website: </strong> <a href="https://www.promptdairytech.com/" target="_blank">https://www.promptdairytech.com</a></li>
      </ul>
    </section>
  </main>
</div>
